const p={"breakpoint-sm":"640px","breakpoint-md":"768px","breakpoint-lg":"1024px","breakpoint-xl":"1280px","breakpoint-xxl":"1536px","breakpoint-2xl":"1536px"};export{p as breakpoints};
